
<script> 
import {
  required,
} from "vuelidate/lib/validators";
import { notify } from '@/helpers/notify' 
import groupModal from './group_modal.vue'

export default {
  name: 'CreateModal',
  props:[
    "list"
  ],
  data() {
    return {
      loading:false,
      subsList:[],
      options: [],
      personelList: [],
      groupList: [],
      form: {
        subject:''
      },
      submitted: false,
    };
  },
  validations: {
    form: {
      subs_id: { required },
      content: { required },
      priority: { required },
      subject: { required },
      appointment: { required },
      user_id: { required },
    },
  },
  watch:{
    list(props){
      this.form = {...props}
      this.getGroup()
    }
  },
  components: {
    groupModal,
  },
  mounted(){
      this.$http.get('/technic-service/listServicePersonel')
        .then(resp => {
            this.personelList = resp.data.content
        })
        .catch(error => error)
  },
  methods: {
    handleSubmit() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;

      } else {
        if(this.form.id)
          this.update();
        else
          this.create();
      }
      this.submitted = false;
    },
    create(){
      this.$http.post('/technic-service/store', this.form)
        .then(resp => {
          this.form = {};
          return notify.success(resp.data.message)
        })
        .catch(error => error)
    },
    update(){
      this.$http.put('/technic-service/' + this.form.id , this.form)
        .then(resp => {
          this.form = {};
          return notify.success(resp.data.message)
        })
        .catch(error => error)
    },
    remove(id){
      this.$http.delete('/technic-service/' + id)
        .then(resp => {
          if(resp.data.code !==  100)  return notify.error(resp.data.message)
           return notify.success(resp.data.message)
         })
        .catch(error => error)
    },
    close(){
      this.$parent.$bvModal.hide('modal-scoped')
    },
    fetchOptions(search, loading ){
    if(search.length) {
        loading(true);
        this.$http.get('/members/search/'+ search)
            .then(resp => {
              this.subsList = resp.data.content
              loading(false);
            })
            .catch(error => error)
      }
    },
    mainGroup(){
      this.$bvModal.show('mainstok-modal-scoped')
    },
    getGroup(){
      this.$http.post('/technic-service/group')
        .then(resp => {
            this.groupList= resp.data
         })
        .catch(error => error)
    },
  },
};
</script>

<template>
  <b-modal id="modal-scoped" size="lg"  title="Teknik Servis Ekle"  no-close-on-backdrop hide-footer>
  <group-modal :groupList="groupList" />
      <form @submit.prevent="handleSubmit">
        <div class="row">
           <div class="col-12">
            <div class="mb-3">
              <label for="subs_id">Abonelik</label>
                <v-select  
                  v-model="form.subs_id"
                  @search="fetchOptions" 
                  :options="subsList"
                  :reduce="form => form.id"
                  :get-option-label="(option) => option.username">
                  <template #option="{ fname, lname, username }">
                    {{ fname }} {{ lname }} - <cite>{{ username }}</cite>
                  </template>
              </v-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <div class="mb-3">
              <label for="appointment">Randevu Tarihi</label>
                <b-form-input
                v-model="form.appointment"
                  id="appointment"
                  value="2019-08-19T13:45:00"
                  type="datetime-local"
                ></b-form-input>
              <div
                v-if="submitted && !$v.form.appointment.required"
                class="invalid-feedback"
              >
              Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="mb-3">
              <div class="d-flex justify-content-between">
                <label for="subject">Arıza Tanımı</label><span class="text-warning cursor-pointer" @click="mainGroup()">Düzenle</span>
              </div>
              <v-select 
                v-model="form.subject"
                :options="groupList"
                :reduce="form => form.id"
                label="name">
              <span slot="no-options">Sonuç Bulunamadı</span>
              </v-select>
              <div
                v-if="submitted && !$v.form.subject.required"
                class="invalid-feedback"
              >
              Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="mb-3">
              <label for="priorty">Öncelik</label>
               <v-select 
                v-model="form.priority" 
                :options="[{ id:1, title: 'Önemli', img: 'danger' },
                           { id:2, title: 'Orta', img: 'info' },
                           { id:3, title: 'Düşük', img: 'success' }]"
                :reduce="form => form.id"
                label="title">
                 <template #option="{ img, title }">
                    <i class="bx bxs-flag-alt" :class="`text-${img}`"></i> &nbsp;&nbsp; {{ title }}
                </template> 
                <template #selected-option="{ img, title }">
                  <div style="display: flex; align-items: baseline">
                      <i class="bx bxs-flag-alt" :class="`text-${img}`"></i> &nbsp;&nbsp; {{ title }}
                  </div>
                </template>
              <span slot="no-options">Sonuç Bulunamadı</span>
              </v-select>
              <div
                v-if="submitted && !$v.form.priority.required"
                class="invalid-feedback"
              >
              Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
           <div class="col-12">
            <div class="mb-3">
              <label for="content">Servis Detayı</label>
              <textarea
                id="content"
                v-model="form.content"
                type="text"
                class="form-control"
                placeholder="Servis Detayı"
                :class="{
                  'is-invalid': submitted && $v.form.content.$error,
                }"
              >
              </textarea>
              <div
                v-if="submitted && !$v.form.content.required"
                class="invalid-feedback"
              >
              Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="mb-3">
              <label for="content">Ekler</label>
              <input type="file" value="" class="form-control" />
             </div>
          </div>
          <div class="col-12">
            <div class="mb-3">
              <label for="user_id">Aktarılacak Personel</label>
                 <v-select
                    label="name" 
                    v-model="form.user_id"
                    :options="personelList" 
                    :reduce="data => data.id">
                    <span slot="no-options">Sonuç Bulunamadı</span>
                </v-select>
              <div
                v-if="submitted && !$v.form.user_id.required"
                class="invalid-feedback"
              >
              Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
        <div>
          <b-button variant="danger"  v-if="form.id" @click="remove(form.id)">Sil</b-button>
        </div>
        <div>
          <b-button variant="light" @click="close()">Vazgeç</b-button>
          <b-button 
            v-if="form.id"
            type="submit" 
            variant="warning" 
            class="ms-1"
            >Güncelle
          </b-button>
          <b-button 
            v-else
            type="submit" 
            variant="success" 
            class="ms-1"
            >Oluştur
          </b-button>
        </div>
        </div>
      </form>
    </b-modal>
</template>